module.exports = {
	"generation": 12,
	"links_in_ad": 4,
	"items": [
		{
			"id": 45370,
			"name": "In-Vision Explainer HD Videos shot in a Virtual Newsroom Studio",
			"url": "https://studio.envato.com/explore/explainer-videos/45370-in-vision-explainer-hd-videos-shot-in-a-virtual-newsroom-studio",
			"price_from": 275
		},
		{
			"id": 12830,
			"name": "Parallels Plesk Panel Instalation & Configuration",
			"url": "https://studio.envato.com/explore/server-admin/12830-parallels-plesk-panel-instalation-configuration",
			"price_from": 100
		},
		{
			"id": 38913,
			"name": "1 Hour Remote Support Session",
			"url": "https://studio.envato.com/explore/wordpress-support/38913-remote-support-session-1-hour-max",
			"price_from": 50
		},
		{
			"id": 7150,
			"name": "Wordpress Website SEO Optimization",
			"url": "https://studio.envato.com/explore/wordpress-seo/7150-wordpress-website-seo-optimization",
			"price_from": 150
		},
		{
			"id": 939,
			"name": "Professional Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/939-professional-logo-design",
			"price_from": 100
		},
		{
			"id": 5108,
			"name": "Adaptive Logo Design",
			"url": "https://studio.envato.com/explore/logo-design/5108-adaptive-logo-design",
			"price_from": 60
		},
		{
			"id": 3891,
			"name": "UX/UI Design for Mobile and Web Apps",
			"url": "https://studio.envato.com/explore/app-design/3891-ux-ui-design-for-mobile-and-web-apps",
			"price_from": 300
		},
		{
			"id": 16089,
			"name": "PSD to Responsive Email template for MailChimp",
			"url": "https://studio.envato.com/explore/email-design-development/16089-psd-to-responsive-email-template-for-mailchimp-or-any-email-marketing-platform",
			"price_from": 100
		},
		{
			"id": 9333,
			"name": "Shopify Store Setup/Creation",
			"url": "https://studio.envato.com/explore/shopify-development/9333-shopify-store-setup-creation",
			"price_from": 1200
		},
		{
			"id": 39161,
			"name": "Website to IOS / IPad App",
			"url": "https://studio.envato.com/explore/app-development/39161-website-to-ios-ipad-app",
			"price_from": 100
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./config/sites/studio-recommendations/codecanyon.json
// module id = 487
// module chunks = 1